import React from 'react';
import { Trans } from '@lingui/react';
import { isMobileOnly } from 'react-device-detect';
import vieweet from '../../../../images/vieweet-logo/vieweet-logo.svg';
import x from '../../../../images/vieweet-logo/x.svg';

interface IProps {
  logoUrl: string;
  email: string;
}

const UserAlreadyExistsDiffPartner: React.FC<IProps> = ({ logoUrl, email }) => {
  if (isMobileOnly) {
    return (
      <div className='initial-pages-bg'>
        <div className='onboarding-content-layout'>
          <div className='sign-up-partners-logo'>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={vieweet} alt='vieweet' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={x} alt='x' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={logoUrl} alt='x' />
            </div>
          </div>
          <div
            className='activate-account-initial-pages-container'
            style={{ padding: '40px 20px', width: '85%', height: '75%', transform: 'translate(-50%, -40%)' }}
          >
            <div className='activate-account-container-mobile'>
              <div data-testid='not-activated-text' className='title-activate-account-mobile'>
                <Trans id='Account Not Linked to EPC Choice' />
              </div>
              <div className='message-partner'>
                <div className='sub-text-activate-account' style={{ color: '#000' }}>
                  Your account exists, but it's not yet allocated under the EPC Choice Admin.
                </div>
                <div className='sub-text-activate-account' style={{ color: '#000' }}>
                  Click the button below to open the Vieweet App and log in.
                </div>
              </div>
              <div className='a-ac-btn-container-link-partner button-hover'>
                <a href={`mailto:marketing@vieweet.com?subject=EPC Choice account ${email}`} style={{ textDecoration: 'none' }}>
                  Contact Support
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className='initial-pages-bg'>
        <div className='onboarding-content-layout'>
          <div className='sign-up-partners-logo'>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={vieweet} alt='vieweet' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={x} alt='x' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={logoUrl} alt='x' />
            </div>
          </div>
          <div />
          <div className='activate-account-initial-pages-container-partner'>
            <div className='activate-account-container-partner'>
              <React.Fragment>
                <div data-testid='not-activated-text' className='title-activate-account-partner'>
                  Account Not Linked
                </div>
                <div data-testid='not-activated-text' className='title-activate-account-partner'>
                  to EPC Choice
                </div>
                <div className='message-partner' style={{ marginTop: '40px' }}>
                  <div className='sub-text-activate-account' style={{ color: '#000' }}>
                    Your account exists, but it's not yet allocated under the EPC Choice Admin.
                  </div>
                  <div className='sub-text-activate-account' style={{ color: '#000' }}>
                    Please <b>contact us to complete the setup</b> and ensure you're correctly assigned.
                  </div>
                </div>
                <div className='a-ac-btn-container-link-partner button-hover'>
                  <a href={`mailto:marketing@vieweet.com?subject=EPC Choice account ${email}`} style={{ textDecoration: 'none' }}>
                    Contact Support
                  </a>
                </div>
              </React.Fragment>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default UserAlreadyExistsDiffPartner;
